/*!
 * Copyright (c) 2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var ControllerProofPurpose = require('./ControllerProofPurpose');

module.exports = /*#__PURE__*/function (_ControllerProofPurpo) {
  _inherits(PublicKeyProofPurpose, _ControllerProofPurpo);

  function PublicKeyProofPurpose() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        controller = _ref.controller,
        date = _ref.date,
        _ref$maxTimestampDelt = _ref.maxTimestampDelta,
        maxTimestampDelta = _ref$maxTimestampDelt === void 0 ? Infinity : _ref$maxTimestampDelt;

    _classCallCheck(this, PublicKeyProofPurpose);

    return _possibleConstructorReturn(this, _getPrototypeOf(PublicKeyProofPurpose).call(this, {
      term: 'publicKey',
      controller: controller,
      date: date,
      maxTimestampDelta: maxTimestampDelta
    }));
  }

  _createClass(PublicKeyProofPurpose, [{
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(proof) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", proof);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function update(_x) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "match",
    value: function () {
      var _match = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(proof) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", proof.proofPurpose === undefined);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function match(_x2) {
        return _match.apply(this, arguments);
      }

      return match;
    }()
  }]);

  return PublicKeyProofPurpose;
}(ControllerProofPurpose);